import React, { useContext, useEffect } from "react";
import { Form } from "antd";

import { Courses } from "./courses";
import { FormContainer } from "../../../../../../shared";
import { fieldValidationMessages } from "../../../../../../../utils";
import {
  NewExpertContext
} from "../../../../../../../contexts/experts/new/context";

const { Item } = Form;

export const CoursesAndCertificationsForm = ({
  editable = true
}) => {
  const {
    onFormFieldsChange,
    form,
    data = {}
  } = useContext(NewExpertContext);

  const { user = {} } = data;
  const {
    courses = []
  } = user?.expertProfile?.professionalExperience || {};

  useEffect(() => {
    form.setFieldsValue({
      courses
    });
  }, [data]);

  return (
    <FormContainer>
      <Form
        validateMessages={fieldValidationMessages}
        onFieldsChange={onFormFieldsChange}
        form={form}
        layout="vertical">
        <Item
          name="courses"
          trigger="onSave"
          valuePropName="courses"
          initialValue={courses}
          label={editable && "Cursos y certificaciones"}
          rules={[{ required: true }]}>
          <Courses editable={editable} />
        </Item>
      </Form>
    </FormContainer>
  );
};
